import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateChannelGuideDocument } from './update.generated';

export const useUpdateChannelGuide = (
  options: ApiOptions<typeof UpdateChannelGuideDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateChannelGuideDocument, {
    ...useNotifications(UpdateChannelGuideDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.channel_guides.update_success'),
    }),

    ...options,
  });
};
